<script>
import ManageAllocationFormHeader from '../ManageAllocationFormHeader/ManageAllocationFormHeader.vue';
import ManageAllocationFormAccept from '../ManageAllocationFormAccept/ManageAllocationFormAccept.vue';
import {validateValidDate} from "../../services/ValidatorService";
import {mapState, mapActions} from 'vuex';

export default {
    components: {
        ManageAllocationFormHeader,
        ManageAllocationFormAccept
    },
    computed: {
        ...mapState({
            item: state => state.allocation.request.item,
            itemIndex: state => state.allocation.request.itemIndex,
            items: state => state.allocation.request.items.pending,
            editMode: state => state.allocation.request.editMode
        }),
        releaseDateClasses() {
            return {
                'manage-allocation-request-form__units--error': this.$v.item.changes.release.releaseDate.$dirty && this.$v.item.changes.release.releaseDate.$error,
                'manage-allocation-request-form__units--success': this.$v.item.changes.release.releaseDate.$dirty && !this.$v.item.changes.release.releaseDate.$error
            }
        }
    },
    methods: {
        ...mapActions({
            submit: 'allocation/submitForm',
            requestItemSet: 'allocation/requestItemSet',
            requestAcceptModify: 'allocation/requestAcceptModify',
            requestEditToggle: 'allocation/requestEditToggle'
        }),
        update(obj) {
            this.$v.$touch();
            this.requestItemSet(obj);
        }
    },
    validations() {
        return {
            item: {
                changes: {
                    release: {
                        releaseDate: {
                            valid: (value) => {
                                return !this.items[this.itemIndex].changes.release.releaseDate || value.length === 10;
                            },
                            validateValidDate: (date) => {
                                return !this.items[this.itemIndex].changes.release.releaseDate || validateValidDate(date);
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>
<template>
    <div class="manage-allocation-request-form">
        <div v-if="editMode" class="manage-allocation-request-form__content">
            <div class="manage-allocation-request-form__header">
                <div class="manage-allocation-request-form__left">
                    <div class="manage-allocation-request-form__heading">
                        {{ $t('manageAllocationRequest.form.header.heading') }}
                    </div>
                </div>
                <div class="manage-allocation-request-form__right">
                    <div class="manage-allocation-request-form__toggle" @click="requestEditToggle(false)">
                        <i class="fa fa-chevron-left"/>
                    </div>
                </div>
            </div>
            <div class="manage-allocation-request-form__body">
                {{ $t('manageAllocationRequest.form.body') }}
            </div>
            <div class="manage-allocation-request-form__period">
                <div class="manage-allocation-request-form__period-title">
                    {{ $t('manageAllocationRequest.form.period.title') }}
                </div>
                <div class="manage-allocation-request-form__period-body">
                    {{ item.from }} - {{ item.to }}
                </div>
            </div>
            <div class="manage-allocation-request-form__fields">
                <div class="manage-allocation-request-form__field">
                    <div class="manage-allocation-request-form__label">
                        {{ $t('manageAllocationRequest.form.labels.units') }}
                    </div>
                    <button :disabled="!items[itemIndex].changes.deduction.requested"
                            class="manage-allocation-request-form__increment-btn"
                            @click="update({deduction: {units: item.changes.deduction.units - 1}})">
                        -
                    </button>
                    <input v-number-only :value="item.changes.deduction.units ? item.changes.deduction.units : 0"
                           :disabled="!items[itemIndex].changes.deduction.requested"
                           type="text"
                           class="manage-allocation-request-form__input manage-allocation-request-form__units"
                           @input="update({deduction: {units: $event.target.value}})">
                    <button :disabled="!items[itemIndex].changes.deduction.requested"
                            class="manage-allocation-request-form__decrement-btn"
                            @click="update({deduction: {units: parseInt(item.changes.deduction.units) + 1}})">
                        +
                    </button>
                </div>
                <div class="manage-allocation-request-form__field">
                    <div class="manage-allocation-request-form__label">
                        {{ $t('manageAllocationRequest.form.labels.release') }}
                    </div>
                    <input v-mask="'##/##/####'"
                           v-if="items[itemIndex].changes.release.releaseDate" :placeholder="'##/##/####'"
                           :class="releaseDateClasses"
                           :value="item.changes.release.releaseDate"
                           type="text"
                           class="manage-allocation-request-form__input"
                           @input="update({release: {releaseDate: $event.target.value}})">
                    <button v-if="items[itemIndex].changes.release.releaseDays" class="manage-allocation-request-form__increment-btn"
                            @click="update({release: {releaseDays: item.changes.release.releaseDays - 1}})">
                        -
                    </button>
                    <input v-number-only
                           v-if="items[itemIndex].changes.release.releaseDays" :placeholder="'days'"
                           :value="item.changes.release.releaseDays"
                           type="text"
                           class="manage-allocation-request-form__input manage-allocation-request-form__units"
                           @input="update({release: {releaseDays: $event.target.value}})">
                    <button v-if="items[itemIndex].changes.release.releaseDays" class="manage-allocation-request-form__decrement-btn"
                            @click="update({release: {releaseDays: parseInt(item.changes.release.releaseDays) + 1}})">
                        +
                    </button>
                    <input v-if="!items[itemIndex].changes.release.releaseDays && !item.changes.release.releaseDate"
                           :disabled="true" :value="'n/a'"
                           type="text"
                           class="manage-allocation-request-form__input">
                </div>
            </div>
            <div class="manage-allocation-request-form__controls">
                <div class="manage-allocation-request-form__button-group">
                    <button :disabled="$v.$error" class="manage-allocation-request-form__button-accept" @click="requestAcceptModify">{{ $t('manageAllocationRequest.form.buttons.accept') }}</button>
                    <button class="manage-allocation-request-form__button-cancel" @click="requestEditToggle(false)">{{ $t('manageAllocationRequest.form.buttons.cancel') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationRequestForm/ManageAllocationRequestForm.vue